module.exports = __webpack_public_path__ + "static/media/right-arrow.e8fd2ae4.svg";